export default __webpack_public_path__ + "static/media/dark_mode_icon.5053bfcf.svg";